// Utility to detect if user is on mobile
export const isMobileBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
};

// Utility to manage session token with mobile-friendly fallbacks
export const sessionManager = {
  setToken: (token) => {
    if (!token) {
      console.warn('⚠️ Attempted to store empty token');
      return;
    }
    
    try {
      // Store in both localStorage and sessionStorage for redundancy
      localStorage.setItem('session_token', token);
      sessionStorage.setItem('session_token', token);
      
      // Also store in a cookie as fallback for mobile browsers
      // that have issues with localStorage in certain contexts
      const maxAge = 7 * 24 * 60 * 60; // 7 days
      document.cookie = `tb_session=${token}; path=/; max-age=${maxAge}; SameSite=Lax`;
      
      console.log('✅ Session token stored:', token.substring(0, 10) + '...');
    } catch (e) {
      console.error('❌ Error storing session token:', e);
      // Try sessionStorage only if localStorage fails (private browsing)
      try {
        sessionStorage.setItem('session_token', token);
      } catch (e2) {
        console.error('❌ sessionStorage also failed:', e2);
      }
    }
  },
  
  getToken: () => {
    try {
      // Try localStorage first
      let token = localStorage.getItem('session_token');
      
      // Fallback to sessionStorage
      if (!token) {
        token = sessionStorage.getItem('session_token');
      }
      
      // Fallback to cookie (for mobile browsers with localStorage issues)
      if (!token) {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
          const [name, value] = cookie.trim().split('=');
          if (name === 'tb_session') {
            token = value;
            break;
          }
        }
      }
      
      if (token) {
        console.log('🔍 Retrieved session token:', token.substring(0, 10) + '...');
      }
      return token;
    } catch (e) {
      console.error('❌ Error retrieving session token:', e);
      return null;
    }
  },
  
  clearToken: () => {
    try {
      localStorage.removeItem('session_token');
      sessionStorage.removeItem('session_token');
      // Clear cookie
      document.cookie = 'tb_session=; path=/; max-age=0';
      console.log('🗑️ Session token cleared');
    } catch (e) {
      console.error('❌ Error clearing session token:', e);
    }
  },
  
  hasToken: () => {
    return !!sessionManager.getToken();
  }
};
